import { useEffect, useState } from 'react';
import { ISelectOption } from '@widgets/multi-select';
import { useAccountOptions } from '@app/queries/options/useAccountOptions';
import { useClientOptions } from '@app/queries/options/useClientOptions';
import { useRegionOptions } from '@app/queries/options/useRegionOptions';
import { useSourceOptions } from '@app/queries/options/useSourceOptions';
import { useTagOptions } from '@app/queries/options/useTagOptions';
import { useAccountTypeOptions } from '@app/queries/options/useAccountTypeOptions';
import { useManagerOptions } from '@app/queries/options/useManagerOptions';

export interface IAccountEditOptions {
  isLoading: boolean;
  regionOptions: ISelectOption[];
  sourceOptions: ISelectOption[];
  tagOptions: ISelectOption[];
  clientOptions: ISelectOption[];
  accountTypeOptions: ISelectOption[];
  accountOptions: ISelectOption[];
  managerOptions: ISelectOption[];
}

function useAccountEditOptions(): IAccountEditOptions {
  const regionOptionsFetcher = useRegionOptions();
  const sourceOptionsFetcher = useSourceOptions();
  const tagOptionsFetcher = useTagOptions();
  const clientOptionsFetcher = useClientOptions();
  const accountTypeOptionsFetcher = useAccountTypeOptions();
  const accountOptionsFetcher = useAccountOptions();
  const managerOptionsFetcher = useManagerOptions();

  const [regionOptions, setRegionOptions] = useState<ISelectOption[]>([]);
  const [sourceOptions, setSourceOptions] = useState<ISelectOption[]>([]);
  const [tagOptions, setTagOptions] = useState<ISelectOption[]>([]);
  const [clientOptions, setClientOptions] = useState<ISelectOption[]>([]);
  const [accountTypeOptions, setAccountTypeOptions] = useState<ISelectOption[]>([]);
  const [accountOptions, setAccountOptions] = useState<ISelectOption[]>([]);
  const [managerOptions, setManagerOptions] = useState<ISelectOption[]>([]);

  useEffect(() => {
    (async () => {
      const data = await regionOptionsFetcher.fetchData();
      setRegionOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await sourceOptionsFetcher.fetchData();
      setSourceOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await tagOptionsFetcher.fetchData();
      setTagOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await clientOptionsFetcher.fetchData();
      setClientOptions([{ value: 'create-new-client', label: 'Новый' }, ...data]);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await accountTypeOptionsFetcher.fetch();
      setAccountTypeOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await accountOptionsFetcher.fetchData();
      setAccountOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await managerOptionsFetcher.fetchData();
      setManagerOptions(data);
    })();
  }, []);

  const isLoading = !(
    regionOptionsFetcher.isSuccess &&
    sourceOptionsFetcher.isSuccess &&
    tagOptionsFetcher.isSuccess &&
    clientOptionsFetcher.isSuccess &&
    accountTypeOptionsFetcher.isSuccess &&
    managerOptionsFetcher.isSuccess &&
    accountOptionsFetcher.isSuccess
  );

  return {
    isLoading,
    regionOptions: regionOptionsFetcher.isSuccess ? regionOptions : [],
    sourceOptions: sourceOptionsFetcher.isSuccess ? sourceOptions : [],
    tagOptions: tagOptionsFetcher.isSuccess ? tagOptions : [],
    managerOptions: managerOptionsFetcher.isSuccess ? managerOptions : [],
    clientOptions: clientOptionsFetcher.isSuccess ? clientOptions : [],
    accountTypeOptions: accountTypeOptionsFetcher.isSuccess ? accountTypeOptions : [],
    accountOptions: accountOptionsFetcher.isSuccess ? accountOptions : [],
  };
}

export default useAccountEditOptions;
